import React, { useEffect, useRef, useState } from 'react';
import Button from '../../components/elements/button';
import FormInput from '../../components/elements/form_input';
import { Edit, Trash, Add, Eye } from '../../assets/icons';
import LoadingSpinner from '../../components/elements/LoadingSpinner';
import FarmDetails from '../../components/elements/FarmDetails';
import '../../assets/css/pages/farms.css';
import '../../assets/css/elements/loading-spinner.css';
import { farmsApi } from '../../network/apis/farms';
// import { set } from 'lodash';

const Farms = () => {
    const [farms, setFarms] = useState([]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

     const fetchFarms = async () => {
            try {
                setLoading(true);
                const response = await farmsApi.getFarms();
                console.log(response);
                if (response.status.toString().toLowerCase() !== "success") {
                    setError(response.statusText || 'Failed to fetch farms');
                } else if (response.data.isEmpty) {
                    setError('No farms data available');
                } else {
                console.log(response.data);
                if (response.data) {
                    setFarms(response.data);
                } else {
                    setFarms([]);
                }
            }
            } catch (error) {
                setError(error.message || 'Failed to fetch farms');
                setFarms([]);
            } finally {
                setLoading(false);
            }
        };

    useEffect(() => {
        fetchFarms();
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

   

    const [showForm, setShowForm] = useState(false);
    const [editingFarm, setEditingFarm] = useState(null);
    const [selectedFarm, setSelectedFarm] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [, setLoadingFarmDetails] = useState(false);

    const handleFarmClick = async (farmId) => {
        try {
            setLoadingFarmDetails(true);
            const response = await farmsApi.getFarm(farmId);
            if (response.data.data) {
                setSelectedFarm(response.data.data);
                console.log(response.data.data);
            }
        } catch (error) {
            console.error('Failed to fetch farm details:', error);
        } finally {
            setLoadingFarmDetails(false);
        }
    };

    const handleFarmEdit = async (farmId) => {
    try {
            setLoadingFarmDetails(true);
            const response = await farmsApi.getFarm(farmId);
            if (response.data.data) {
                setEditingFarm(response.data.data);
                setFormData(response.data.data);
                setShowForm(true);
            }
        } catch (error) {
            console.error('Failed to fetch farm details:', error);
        } finally {
            setLoadingFarmDetails(false);
        }
    };

    const handleFarmAdd = () => {
        setEditingFarm(null);
        setFormData({
            name: '',
            address: '',
            city: '',
            state: '',
            postal_code: '',
            longitude: '',
            latitude: '',
            size: '',
            species: '',
            capacity: '',
            water_source: '',
            established_date: '',
            owner: JSON.parse(localStorage.getItem('user')).id
        });
        setShowForm(true);
    };

    const [formData, setFormData] = useState({
        name: '',
        address: '',
        city: '',
        state: '',
        postal_code: '',
        longitude: '',
        latitude: '',
        size: '',
        species: '',
        capacity: '',
        water_source: '',
        established_date: '',
        owner: JSON.parse(localStorage.getItem('user')).id
    });

     const geocodeTimeoutRef = useRef(null);
        // Add state for address lookup
        const [addressLookup, setAddressLookup] = useState({
            loading: false,
            options: [],
            error: null
        });
    
        // Geocode function to get coordinates from address
        const geocodeAddress = async (address) => {
            if (!address.trim()) {
                return;
            }
            
            try {
                setAddressLookup(prev => ({ ...prev, loading: true, error: null }));
                
                // Replace with your preferred geocoding API
                // Example using Nominatim (OpenStreetMap)
                const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=5`);
                const data = await response.json();
                
                if (data && data.length > 0) {
                    setAddressLookup(prev => ({
                        ...prev,
                        loading: false,
                        options: data.map(item => ({
                            address: item.display_name,
                            lat: item.lat,
                            lon: item.lon
                        }))
                    }));
                } else {
                    setAddressLookup(prev => ({
                        ...prev,
                        loading: false,
                        options: [],
                        error: "No locations found"
                    }));
                }
            } catch (error) {
                console.error("Geocoding error:", error);
                setAddressLookup(prev => ({
                    ...prev,
                    loading: false,
                    error: "Failed to look up address"
                }));
            }
        };
    
        // Handle address change with debounce
        const handleAddressChange = (e) => {
            const address = e.target.value;
            setFormData({...formData, address: address});
            
            // Clear previous timeout
            if (geocodeTimeoutRef.current) {
                clearTimeout(geocodeTimeoutRef.current);
            }
            
            // Set new timeout for geocoding
            geocodeTimeoutRef.current = setTimeout(() => {
                if (address.length > 5) { // Only geocode if address is substantial
                    geocodeAddress(address);
                } else {
                    setAddressLookup({
                        loading: false,
                        options: [],
                        error: null
                    });
                }
            }, 1000); // Delay by 1 second
        };
    
        // Select an address from suggestions
        const selectAddress = (option) => {
            setFormData({
                ...formData,
                address: option.address,
                city: option.city || formData.city,
                state: option.state || formData.state,
                postal_code: option.postal_code || formData.postal_code,
                latitude: parseFloat(option.lat).toFixed(6),
                longitude: parseFloat(option.lon).toFixed(6)
            });
            setAddressLookup(prev => ({...prev, options: []}));
        };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (editingFarm) {
            setFarms(farms.map(farm => 
                farm.id === editingFarm.id ? {...formData, id: farm.id} : farm
            ));
        } else {
            const response = await farmsApi.addFarm(formData);
            if (response.status !== 200) {
                console.error('Error creating farm:', response.statusText);
                setError('Failed to create farm');
                return;
            } else {
                const newFarm = await response.json();
                // setFarms([...farms, { ...formData, id: Date.now(), status: 'active' }]);
                setFarms([...farms, { ...newFarm, id: newFarm.id, status: 'active' }]);
                setShowForm(false);
                setEditingFarm(null);
            }
        }
        setShowForm(false);
        setEditingFarm(null);
        setFormData({name: '', location: '', size: '', species: [], capacity: '', waterSource: ''});
    };

    const deleteFarm = (id) => {
        if (window.confirm('Are you sure you want to delete this farm?')) {
            setFarms(farms.filter(farm => farm.id !== id));
        }
    };


    return (
        <div className="farms-page">
            <div className="farms-header">
                <h1>Farms</h1>
                <Button 
                    text="Add New Farm"
                    icon={<img src={Add} alt="Add" />}
                    variant="primary"
                    onClick={handleFarmAdd}
                />
            </div>

            {loading ? (
                <LoadingSpinner />
            ) : error ? (
                <div className="error-message">{error}</div>
            ) : (
                <div className="table-container">
                    <table className="farms-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Location</th>
                                <th>Size (ha)</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {farms.map(farm => (
                                <tr 
                                    key={farm.id} 
                                    className="farm-row"
                                    onClick={() => handleFarmClick(farm.id)}
                                >
                                    <td>{farm.name}</td>
                                    <td>{farm.city}, {farm.state}</td>
                                    <td>{farm.size}</td>
                                    <td>{new Date(farm.created_at).toLocaleDateString()}</td>
                                    <td>
                                        <div className="farm-actions">
                                            <button 
                                                className="action-button edit"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleFarmEdit(farm.id);
                                                }}
                                            >
                                                <img src={Edit} alt="Edit" />
                                            </button>
                                            <button 
                                                className="action-button delete"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    deleteFarm(farm.id);
                                                }}
                                            >
                                                <img src={Trash} alt="Delete" />
                                            </button>
                                            <button 
                                                className="action-button view"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleFarmClick(farm.id);
                                                }}
                                            >
                                                <img src={Eye} alt="View" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {selectedFarm && (
                <FarmDetails 
                    farm={selectedFarm} 
                    onClose={() => setSelectedFarm(null)}
                />
            )}

          


            {showForm && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>{editingFarm ? 'Edit Farm' : 'Add New Farm'}</h2>
                        <form onSubmit={handleSubmit}>
                            <FormInput
                                label="Farm Name"
                                value={formData.name}
                                showLabel
                                onChange={(e) => setFormData({...formData, name: e.target.value})}
                                required
                            />
                            <FormInput
                                label="Size (hectares)"
                                value={formData.size}
                                showLabel
                                onChange={(e) => setFormData({...formData, size: e.target.value})}
                                required
                            />
                            <FormInput
                                label="Species (comma separated)"
                                showLabel
                                value={formData.species}
                                onChange={(e) => setFormData({
                                    ...formData, 
                                    species: e.target.value
                                })}
                                required
                            />
                            <FormInput
                                label="Capacity"
                                type="number"
                                showLabel
                                value={formData.capacity}
                                onChange={(e) => setFormData({...formData, capacity: e.target.value})}
                                required
                            />
                            <FormInput
                                label="Water Source"
                                showLabel
                                value={formData.water_source}
                                onChange={(e) => setFormData({...formData, water_source: e.target.value})}
                                required
                            />
                            <FormInput
                                label="Date Established"
                                type="date"
                                showLabel
                                value={formData.established_date}
                                onChange={(e) => setFormData({...formData, established_date: e.target.value})}
                                helpText="When was this farm established?"
                            />
                            
                                    <div className="location-section">
                                <h3 className="section-title">📍 Location Details</h3>
                                
                                <div className="address-input-container">
                                    <FormInput
                                        label="Address"
                                        value={formData.address}
                                        showLabel
                                        required
                                        onChange={handleAddressChange}
                                        placeholder="Start typing to search for address..."
                                        helpText="Enter at least 6 characters to search"
                                    />
                                    
                                    {addressLookup.loading && (
                                        <div className="address-loading">
                                            <div className="address-spinner"></div>
                                            <span>Searching addresses...</span>
                                        </div>
                                    )}
                                    
                                    {addressLookup.options.length > 0 && (
                                        <div className="address-suggestions">
                                            <div className="suggestions-header">
                                                <span>📌 Select an address</span>
                                                <button 
                                                    type="button" 
                                                    className="close-suggestions"
                                                    onClick={() => setAddressLookup(prev => ({...prev, options: []}))}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                            {addressLookup.options.map((option, index) => (
                                                <div 
                                                    key={index}
                                                    className="address-option"
                                                    onClick={() => selectAddress(option)}
                                                >
                                                    <span className="address-text">{option.address}</span>
                                                    <span className="address-coords">
                                                        <span className="coord-label">Lat:</span> {parseFloat(option.lat).toFixed(4)}
                                                        <span className="coord-separator">|</span>
                                                        <span className="coord-label">Lng:</span> {parseFloat(option.lon).toFixed(4)}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    
                                    {addressLookup.error && (
                                        <div className="address-error">
                                            <span className="error-icon">⚠️</span>
                                            {addressLookup.error}
                                        </div>
                                    )}
                                </div>
                                
                                <div className="coordinates-display">
                                    <div className="coordinates-header">
                                        <span className="coordinates-title">GPS Coordinates</span>
                                        {(formData.latitude && formData.longitude) && (
                                            <span className="coordinates-status success">✓ Set</span>
                                        )}
                                        {(!formData.latitude || !formData.longitude) && (
                                            <span className="coordinates-status pending">Awaiting address</span>
                                        )}
                                    </div>
                                    
                                    <div className="coordinates-grid">
                                        <div className="coordinate-field">
                                            <label>
                                                <span className="coord-icon">↕</span>
                                                Latitude
                                            </label>
                                            <div className="coordinate-value-container">
                                                <input 
                                                    type="text"
                                                    value={formData.latitude || ""}
                                                    onChange={(e) => setFormData({...formData, latitude: e.target.value})}
                                                    readOnly={!!formData.latitude}
                                                    placeholder="Auto-filled from address"
                                                    className={formData.latitude ? 'has-value' : ''}
                                                />
                                                {formData.latitude && (
                                                    <button 
                                                        type="button" 
                                                        className="clear-coordinate"
                                                        onClick={() => setFormData({...formData, latitude: ''})}
                                                        title="Clear latitude"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        
                                        <div className="coordinate-field">
                                            <label>
                                                <span className="coord-icon">↔</span>
                                                Longitude
                                            </label>
                                            <div className="coordinate-value-container">
                                                <input 
                                                    type="text"
                                                    value={formData.longitude || ""}
                                                    onChange={(e) => setFormData({...formData, longitude: e.target.value})}
                                                    readOnly={!!formData.longitude}
                                                    placeholder="Auto-filled from address"
                                                    className={formData.longitude ? 'has-value' : ''}
                                                />
                                                {formData.longitude && (
                                                    <button 
                                                        type="button" 
                                                        className="clear-coordinate"
                                                        onClick={() => setFormData({...formData, longitude: ''})}
                                                        title="Clear longitude"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="city-state-grid">
                                    <FormInput
                                        label="City"
                                        value={formData.city}
                                        showLabel
                                        onChange={(e) => setFormData({...formData, city: e.target.value})}
                                        required
                                    />
                                    <FormInput
                                        label="State"
                                        value={formData.state}
                                        showLabel
                                        onChange={(e) => setFormData({...formData, state: e.target.value})}
                                        required
                                    />
                                    <FormInput
                                        label="Postal Code"
                                        value={formData.postal_code}
                                        showLabel
                                        onChange={(e) => setFormData({...formData, postal_code: e.target.value})}
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="form-actions">
                                <Button 
                                    text="Cancel"
                                    variant="outline"
                                    onClick={() => {
                                        setShowForm(false);
                                        setEditingFarm(null);
                                    }}
                                />
                                <Button 
                                    text={editingFarm ? 'Save Changes' : 'Add Farm'}
                                    type="submit"
                                    variant="primary"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Farms;